/*
 * @Author: caizr 13149329917@163.com
 * @Date: 2023-01-10 16:26:39
 * @LastEditors: caizr 13149329917@163.com
 * @LastEditTime: 2023-01-10 16:26:52
 * @FilePath: \cladogram\src\api\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/****   http.js   ****/
// 导入封装好的axios实例
import request from './request';

const http = {
  /**
   * methods: 请求方式
   * url 请求地址
   * params 请求参数
   */
  get(url, params) {
    const config = {
      method: 'get',
      url: url
    };
    if (params) config.params = params;
    return request(config);
  },
  post(url, params) {
    const config = {
      method: 'post',
      url: url
    };
    if (params) config.data = params;
    return request(config);
  },
  put(url, params) {
    const config = {
      method: 'put',
      url: url
    };
    if (params) config.params = params;
    return request(config);
  },
  delete(url, params) {
    const config = {
      method: 'delete',
      url: url
    };
    if (params) config.params = params;
    return request(config);
  }
};
//导出
export default http;



// WEBPACK FOOTER //
// ./src/utils/http.js